import React, { useEffect, useState, useMemo } from 'react'
import { Marker, Popup, useMap, useMapEvents } from 'react-leaflet'
import L from 'leaflet'
import { APP_THEMES } from '../../utils/appTheme'
import { getAppType } from '../../utils/appType'

function createMarkerIcon() {
  const color = APP_THEMES[getAppType()].primary
  return new L.Icon({
    iconUrl:
      'data:image/svg+xml;base64,' +
      btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="${color}" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin">
        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" fill="${color}" stroke="${color}"/>
        <circle cx="12" cy="10" r="3" fill="none" stroke="#ffffff" stroke-width="2"/>
      </svg>`),
    iconSize: [38, 38],
    iconAnchor: [19, 38],
    popupAnchor: [0, -38],
  })
}

type Props = {
  position: L.LatLng | null
  setPosition: (position: L.LatLng) => void
  showMyLocation: boolean
}

const LocationMarker: React.FC<Props> = (props) => {
  const icon = useMemo(() => createMarkerIcon(), [])
  return props.position === null ? null : (
    <Marker position={props.position} icon={icon} />
  )
}

export default LocationMarker
